import React, { useRef, useEffect, useState } from 'react';
import { Box, keyframes, Tooltip } from '@mui/material';

const createMarqueeAnimation = (textWidth, containerWidth) => keyframes`
  0% {
    transform: translateX(${containerWidth}px);
  }
  100% {
    transform: translateX(-${textWidth}px);
  }
`;

const MarqueeText = ({ text, speed = 20, style, className }) => {
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const [shouldScroll, setShouldScroll] = useState(false);
  const [animation, setAnimation] = useState(null);

  useEffect(() => {
    const checkScroll = () => {
      if (!containerRef.current || !textRef.current) return;

      const containerWidth = containerRef.current.offsetWidth;
      const textWidth = textRef.current.scrollWidth;

      if (textWidth > containerWidth) {
        setShouldScroll(true);
        setAnimation(createMarqueeAnimation(textWidth, containerWidth));
      } else {
        setShouldScroll(false);
        setAnimation(null);
      }
    };

    checkScroll();
    window.addEventListener('resize', checkScroll);

    return () => window.removeEventListener('resize', checkScroll);
  }, [text]);

  return (
    <Box
      ref={containerRef}
      sx={{
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: '100%',
        position: 'relative',
      }}
    >
      <Tooltip title={text} placement="top" arrow>
        <Box
          ref={containerRef}
          sx={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            width: '100%',
            position: 'relative',
            display: 'block', // ensures it's a block-level tooltip target
          }}
        >
          <Box
            ref={textRef}
            component="span"
            style={style}
            sx={{
              display: 'inline-block',
              whiteSpace: 'nowrap',
              ...(shouldScroll &&
                animation && {
                  animation: `${animation} ${speed}s linear infinite`,
                }),
            }}
          >
            {text}
          </Box>
        </Box>
      </Tooltip>
    </Box>
  );
};

export default MarqueeText;
